<template>
  <div class="wrap result-wrap">
    <div class="content">
      <div class="icon loading"></div>
      <div class="text">{{ $t('loginning') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginCB',
  data () {
    return {
      query: {}
    }
  },
  created () {
    const query = this.getParams()
    const stateData = this.$utils.parseSocialOauthState(query.state)
    this.query = {
      ...query,
      ...stateData
    }
    console.log(query, stateData, { ...this.query })

    if (this.query.platform === 'discord') this.discordLogin()
  },
  methods: {
    getParams () {
      const search = window.newLocation.search || window.newLocation.hash
      const query = search.substring(1)
      const vars = query ? query.split('&') : []
      const params = {}
      vars.forEach(item => {
        const pair = item.split('=')
        params[pair[0]] = decodeURIComponent(pair[1])
      })
      return params
    },

    async discordLogin () {
      // oauth授权回调处理
      const accessToken = this.query.access_token
      localStorage.setItem('discordToken', `${localStorage.getItem('discordKey')}__${accessToken}`)
      console.log('window.opener===', window.opener)
      window.opener && window.close()
    }
  }
}
</script>

<style lang='less' scoped >
.wrap {
  height: 100%;
  padding: 0 32px 20px;
  display: flex;
  flex-direction: column;
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_fail.png) center center no-repeat;
    background-size: 100% 100%;
    &.loading {
      background-image: url(~@img/icon_loading.png);
      filter: contrast(0.5);
      animation: infiniteRotate linear 2s infinite;
    }
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
    text-align: center;
  }
  .code-tips {
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #777;
  }
}
@keyframes infiniteRotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>